// src/axios-encuestas.js
import axios from 'axios';
import { baseUrlEncuestas } from './shared/urlApps';

// Mismo patrón de limitador que en axios-dashboard.js
const MAX_REQUESTS_COUNT = 1;
const INTERVAL_MS = 10;
let PENDING_REQUESTS = 0;

const instance = axios.create({
  baseURL: baseUrlEncuestas(),
  headers: { 'Content-Type': 'application/json' }
  // timeout: 15000,       // (opcional) si querés protegerte de cuelgues
  // withCredentials: true // (opcional) si el backend usa cookies
});

instance.interceptors.request.use((config) => {
  return new Promise((resolve) => {
    const interval = setInterval(() => {
      if (PENDING_REQUESTS < MAX_REQUESTS_COUNT) {
        PENDING_REQUESTS++;
        clearInterval(interval);
        resolve(config);
      }
    }, INTERVAL_MS);
  });
});

instance.interceptors.response.use(
  (response) => {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);
    return Promise.resolve(response);
  },
  (error) => {
    PENDING_REQUESTS = Math.max(0, PENDING_REQUESTS - 1);
    return Promise.reject(error);
  }
);

export default instance;
